import { BaseCardValidator } from './BaseCardValidator.ts';
export class CardValidatorOrdered extends BaseCardValidator {
    get cards() {
        const clonedCards = [];
        for (const card of this.state.cards){
            clonedCards.push(card);
        }
        return clonedCards;
    }
}
